import React from 'react';
import type { Proposal } from '../pages/KnowledgePage';

interface Props {
  proposals: Proposal[];
  selectedId: number | null;
  onSelect: (id: number) => void;
}

function statusBadgeClass(status: string): string {
  switch (status) {
    case 'pending': return 'staging-badge--pending';
    case 'edited':  return 'staging-badge--edited';
    case 'approved': return 'staging-badge--approved';
    case 'rejected': return 'staging-badge--rejected';
    default: return '';
  }
}

function formatDate(dateStr: string): string {
  try {
    return new Date(dateStr).toLocaleDateString('en-GB', {
      day: '2-digit', month: 'short', year: 'numeric',
    });
  } catch {
    return dateStr;
  }
}

export default function StagingList({ proposals, selectedId, onSelect }: Props) {
  if (proposals.length === 0) {
    return (
      <div className="staging-list staging-list--empty">
        <p>No proposals matching this filter.</p>
      </div>
    );
  }

  return (
    <div className="staging-list">
      {proposals.map(p => (
        <button
          key={p.id}
          className={`staging-item ${selectedId === p.id ? 'staging-item--selected' : ''}`}
          onClick={() => onSelect(p.id)}
        >
          <div className="staging-item__top">
            <span className={`staging-badge ${statusBadgeClass(p.status)}`}>
              {p.status}
            </span>
            <span className="staging-item__date">{formatDate(p.created_at)}</span>
          </div>
          <span className="staging-item__title">{p.title}</span>
          {p.dim_hazards && (
            <span className="staging-item__category">
              {p.dim_hazards.hazardscategoryname}
            </span>
          )}
          <span className="staging-item__path">{p.target_file_path}</span>
        </button>
      ))}
    </div>
  );
}
